
import { Dialog, DialogSurface, DialogBody, DialogTitle, DialogContent, Spinner, DialogActions, Button } from "@fluentui/react-components";
import React from "react";
type CreatePDFReportProgressModalProps = {
    isLoading: boolean;
    filename?: string;
    filePath?: string;
    isSuccess: boolean;
    isOpened: boolean;

    onHide: () => void;

}

export const CreatePDFReportProgressModal: React.FC<CreatePDFReportProgressModalProps> = (props) => {
    const [open, setOpen] = React.useState(false);
    React.useEffect(() => {
        setOpen(!!props.isOpened);

    }, [props.isOpened]);

    const onModalClose = () => {
        setOpen(false);
        if (props.onHide)
            props.onHide();
    }
    return <Dialog

        open={open}>
        <DialogSurface>

            <DialogBody>
                <DialogTitle>
                    Create PDF report
                </DialogTitle>
                <DialogContent>
                    <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                        {props.isLoading && <Spinner size="extra-small" appearance="primary" label="Create PDF report in progress..." />}
                        {!props.isLoading && !props.isSuccess && <span style={{ color: "red" }}>An error occurred while creating PDF report.</span>}
                        {!props.isLoading && props.isSuccess && <span>
                            File <b>{props.filename}</b> was successfully generated.
                            <br /> File location: <b>{props.filePath}</b>.
                        </span>}
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button appearance="secondary" onClick={onModalClose} type="button">Close</Button>
                </DialogActions>

            </DialogBody>

        </DialogSurface>


    </Dialog>
}